export default "__VITE_PUBLIC_ASSET__45dab235__"